import { Directive } from '@angular/core';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

/**
 * MM/YYYY display for a single datepicker input.
 *
 * Put this on the `<input matInput [matDatepicker]>` element when one field has to
 * read MM/YYYY while the rest of the component keeps its own format — the component's
 * `provideMomentDateAdapter(MY_FORMATS)` applies to every picker in the template, so
 * the override has to sit on the element itself.
 */
export const MONTH_YEAR_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Directive({
  selector: '[monthYearDateFormat]',
  standalone: true,
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS }],
})
export class MonthYearDateFormatDirective { }
